<template>
  <el-cascader
    v-bind="$attrs"
    v-model="innerValue"
    filterable
    clearable
    :placeholder="placeholder"
    :props="config"
    :options="options"
    v-on="$listeners"
  >
    <slot></slot>
    <template #[slotName] v-for="(slot, slotName) in $slots">
      <slot :name="slotName"></slot>
    </template>
  </el-cascader>
</template>

<script>
  import { getAttributionTree } from '@/api/belong/responsibility'
  export default {
    name: 'YdResponsibilitySelect', // 地级归属
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      /**
       * 默认，单选模式，选择末级节点
       * 1 单选模式，可选任意节点
       * 2 多选模式，勾选父节点真正选中的都是叶子节点
       * 3 多选模式，可选任意节点
       *  */
      mode: {
        type: [Number, String],
        default: () => -1
      },
      props: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        innerValue: '',
        options: []
      }
    },
    computed: {
      config() {
        const basicConfig = {
          expandTrigger: 'hover',
          label: 'name',
          value: 'id',
          children: 'children'
        }
        if (parseInt(this.mode) === 1) {
          return { ...basicConfig, checkStrictly: true }
        }
        if (parseInt(this.mode) === 2) {
          return { ...basicConfig, multiple: true }
        }
        if (parseInt(this.mode) === 3) {
          return { ...basicConfig, multiple: true, checkStrictly: true }
        }
        return { ...basicConfig, ...this.props }
      }
    },
    watch: {
      innerValue: {
        handler(newVal, oldVal) {
          if (newVal === oldVal) {
            return
          }
          if (parseInt(this.mode) === 1 && this.options && this.options.length > 0) {
            const relVal = newVal && newVal.length ? newVal[newVal.length - 1] : ''
            if (relVal === this.value) {
              return
            }
            this.$emit('input', relVal)
            return
          }
          this.$emit('input', newVal)
        }
      },
      value: {
        handler(newVal) {
          if (newVal === this.innerValue) {
            return
          }
          if (
            Array.isArray(newVal) &&
            Array.isArray(this.innerValue) &&
            newVal.join(',') === this.innerValue.join(',')
          ) {
            return
          }
          if (parseInt(this.mode) === 1 && this.options && this.options.length > 0) {
            const relVal = this.findParentsId(this.options, newVal) || []
            const reaVal = relVal.reverse()
            if (Array.isArray(this.innerValue) && reaVal.join(',') === this.innerValue.join(',')) {
              return
            }
            this.innerValue = reaVal
            return
          }
          this.innerValue = newVal
        },
        immediate: true
      }
    },
    created() {
      this.getList()
    },
    methods: {
      async getList() {
        const { code, data } = await getAttributionTree()
        if (code !== 0 || !Array.isArray(data)) {
          return
        }
        this.options = this.filterChildNodes(data)
        // 此判断用于解决，value获取到值后，options还没有值，组件没有正确设置值的问题
        if (this.value && parseInt(this.mode) === 1) {
          const relVal = this.findParentsId(this.options, this.value) || []
          const reaVal = relVal.reverse()
          this.innerValue = reaVal
        }
      },
      filterChildNodes(dataList) {
        return dataList.map((item) => {
          if (item.children && item.children.length > 0) {
            item.children = this.filterChildNodes(item.children)
          } else {
            delete item.children
          }
          return item
        })
      },
      // 根据子id找父id,返回值不包含查找的id
      findParentsId(dataList, id) {
        if (dataList.length === 0) {
          return
        }
        for (let i = 0; i < dataList.length; i++) {
          if (dataList[i].id === id) {
            return [dataList[i].id]
          } else {
            if (dataList[i].children) {
              const res = this.findParentsId(dataList[i].children, id)
              if (res) {
                return [...res, dataList[i].id]
              }
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped></style>
